<template>
    <div class="productsSummary" :style="{width: calcWidth}">
        <div v-if="!show" @click="show=true" class="showFromSmall link-primary">
            <p>{{ $t("utils.showSummary") }}</p>
        </div>
        <div class="row" v-if="show">
            <div class=col-12>
                <span @click="showWhole=true" class="link-primary" v-if="!showWhole">
                    {{ $t("utils.showFullSummary") }}
                </span>
                <span @click="showWhole=false" class="link-primary" v-if="showWhole">
                    {{ $t("utils.showSmallerSummary") }}
                </span>
                <span @click="showWhole = false;show=false" class="link-primary ms-5">
                    {{ $t("utils.hideSummary") }}
                </span>
            </div>
            <div class="col-12">
                <div class="row small_text">
                    <div class="col-4">
                        <span>{{ $t("summary.heading.name") }}</span>
                    </div>
                    <div class="col-4">
                        <span>{{ $t("summary.heading.count") }}</span>
                    </div>
                    <div class="col-4">
                        <span>{{ $t("summary.heading.price") }}</span>
                    </div>
                </div>
            </div>
            <div class="col-12" v-for="product in products" :key="product.id">
                <ProductSummaryWholeRow :product="product"/>
            </div>
            <div class="col-12">
                <p>Cena celkem</p>
                <p>0 Kč</p>
            </div>
        </div>
    </div>
</template>

<script>
import ProductSummaryWholeRow from "@/components/calculations/ProductSummaryWholeRow.vue";

export default {
    components: {
        ProductSummaryWholeRow
    },
    data() {
        return {
            showWhole: false,
            show: false,
            products: [],
            loading: false
        }
    },
    created: function () {
        this.load();
    },
    methods: {
        load: function () {
            this.loading = true;
            this.$store.getters.api.get("/products").then(function (response) {
                this.products = response.data.data;
                this.loading = false;
            }.bind(this))
        }
    },
    computed: {
        calcWidth: function () {
            if (this.showWhole) {
                return "75vw";
            }
            if (this.show) {
                return "450px";
            }
            return "50px";
        }
    }
}
</script>
<style lang="scss">
@import '@/scss/abstracts/variables';
.productsSummary {
    position: fixed;
    right:0px;
    top: $navbar-height;
    background-color: white;
    border-left: 2px solid #ccc;
    height: calc(100vh - $navbar-height);
    padding: 10px;
}
.showFromSmall {
    height: calc(100vh - $navbar-height);
    display:flex;
    align-items: center;
    justify-content: center;
    p {
        transform: rotate(90deg);
    }
}
</style>